<template>
  <div class="modal-image-cropper">
    <div v-if="previewSrc" class="modal-image-cropper__preview-img">
      <img :src="previewSrc" alt="" />
    </div>
    <m4-modal v-if="!previewMode" ref="modal" vertical-center size="md" :allow-close-by-clicking-on-bg="false">
      <template v-slot:button>
        <m4-button tag="a" variant="info" left-icon="edit-alt" size="sm">{{ btnTitle }}</m4-button>
      </template>
      <m4-image-cropper ref="cropper" v-bind="$attrs"></m4-image-cropper>
      <div class="modal-image-cropper__actions">
        <m4-button v-if="btnCancelTitle" size="md" @click="onCloseDialog" tag="a">{{ btnCancelTitle }}</m4-button>
        <m4-button size="md" @click="onSubmitDialog" tag="a" variant="primary" class="margin-l-lg">
          {{ btnSubmitTitle }}
        </m4-button>
      </div>
    </m4-modal>
  </div>
</template>
<script>
export default {
  name: "M4ModalImageCropper",
  props: {
    previewSrc: String,
    btnTitle: {
      type: String,
      default: "Edit profile picture"
    },
    btnCancelTitle: {
      type: String,
      default() {
        return "Cancel";
      }
    },
    btnSubmitTitle: {
      type: String,
      default() {
        return "Save";
      }
    },
    previewMode: Boolean
  },
  methods: {
    onCloseDialog() {
      this.$refs.modal.onClickCloseModal();
    },
    onSubmitDialog() {
      this.$refs.cropper.upload();
    }
  }
};
</script>
